import { MapData_Base } from '~/common/typescript/models/MapData';
import { remote_mapDataFile_getInfo } from '~/common/typescript/apis/MapDataFileAPIs';
import { API_URL_ADMIN } from '~/config/config';
import { ParsedMapDataMetadata } from './MapDataMetadataParser';
import { MAP_DATA_SOURCE_ID_PREFIX, MAP_DATA_LAYER_ID_PREFIX } from './MapDataVectorLayer';

export const MapDataRasterLayer = {
  addToMap: async (mapData: MapData_Base, parsed: ParsedMapDataMetadata, theFirstAboveLayerId?: string) => {
    const map = window.map;
    if (!map) return;

    const sourceId = MAP_DATA_SOURCE_ID_PREFIX + mapData.id;
    const layerId = MAP_DATA_LAYER_ID_PREFIX + mapData.id;

    if (map.getLayer(layerId)) {
      map.removeLayer(layerId);
    }
    if (map.getSource(sourceId)) {
      map.removeSource(sourceId);
    }

    const rasterTileFile = mapData.map_data_files?.find((file: any) => file.type === 'mbtiles' || file.type === 'pmtiles');
    if (!rasterTileFile) {
      console.warn('MapDataRasterLayer - No tile file found for raster:', mapData.id);
      return;
    }

    let minzoom: number | undefined;
    let maxzoom: number | undefined;

    if (parsed.gdalInfo) {
      // Parse từ gdalInfo metadata nếu có
      const gdalMetadata = parsed.gdalInfo.metadata || {};
      const zoomMetadata = gdalMetadata[''] || {};
      minzoom = zoomMetadata.minzoom ? parseInt(zoomMetadata.minzoom, 10) : undefined;
      maxzoom = zoomMetadata.maxzoom ? parseInt(zoomMetadata.maxzoom, 10) : undefined;
    } else {
      // Fallback: Lấy minzoom/maxzoom từ tile info
      const tileInfo = await remote_mapDataFile_getInfo(rasterTileFile.path);
      minzoom = tileInfo?.minzoom;
      maxzoom = tileInfo?.maxzoom;
    }

    console.log('MapDataRasterLayer - Raster minzoom/maxzoom:', { minzoom, maxzoom });

    const url = `${API_URL_ADMIN}/api/map-data-file-ext/raster/{z}/{x}/{y}.png?path=${rasterTileFile.path}`;

    map.addSource(sourceId, {
      type: 'raster',
      tiles: [url],
      tileSize: 256,
      minzoom: minzoom,
      maxzoom: maxzoom,
    });

    map.addLayer(
      {
        id: layerId,
        type: 'raster',
        source: sourceId,
        minzoom: minzoom,
        maxzoom: maxzoom,
      },
      theFirstAboveLayerId,
    );

    console.log('MapDataRasterLayer - Added raster layer to map:', mapData.id, mapData.name);
  },
};
